module.exports = __webpack_public_path__ + "static/media/1_en.eaf1cdc2.png";